/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The booking status of a container action.
 */
export enum EnumContainerActionStatus {
    /**
     * Not defined
     */
    NotDefined = 0,
    /**
     * The container action is planned, but not yet ready to be booked
     */
    Planned = 1,
    /**
     * The container action is ready to be booked into the container management
     */
    ToBeBooked = 2,
    /**
     * The container action has been booked into the container management
     */
    Booked = 3,
    /**
     * The container action is claimed by a booking run that is under way
     * 
     * @remarks
     * Never observed outside the transaction that set it: the run either books the action, which
     * overwrites this, or is refused, and a refused run rolls that transaction back explicitly.
     * The claim is written inside it, so nothing — a refusal, a crash, or a caller that would
     * rather commit — can leave a row standing at this status. It exists so a second run in
     * parallel matches no row and leaves the action alone.
     * <para/>
     * That matters because there is no way out of it: a row here can be neither re-marked nor
     * re-booked. Any future path that sets this status has to sit inside a transaction that is
     * rolled back on every failure, or it needs a reclaim rule to go with it.
     */
    Booking = 4,
}
